import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Onboarding.css";

import slide1 from "../assets/images/slide_1d.png";
import slide2 from "../assets/images/slide_2d.png";
import slide3 from "../assets/images/slide_3d.png";

function Onboarding() {
  const [current, setCurrent] = useState(0);
  const [lang, setLang] = useState("en");
  const navigate = useNavigate();
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // Load language from localStorage
  useEffect(() => {
    const storedLang = localStorage.getItem("app_language");
    const isCompleted = localStorage.getItem("is_onboarding_completed") === "true";
    if (storedLang) setLang(storedLang);
    if (isCompleted) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const slides = [
    {
      image: slide1,
      title_en: "Showcase Your Expertise",
      title_ar: "اعرض خبراتك المهنية",
      text_en:
        "Create a professional profile, upload your past projects, and highlight your skills to attract clients.",
      text_ar:
        "أنشئ ملفًا احترافيًا، وحمّل مشاريعك السابقة، وابرز مهاراتك لجذب العملاء.",
    },
    {
      image: slide2,
      title_en: "Get Work Requests Instantly",
      title_ar: "احصل على طلبات العمل فوراً",
      text_en:
        "Receive real-time notifications when customers post new service requests in your category.",
      text_ar:
        "استقبل إشعارات فورية عند نشر العملاء طلبات خدمة جديدة في فئتك.",
    },
    {
      image: slide3,
      title_en: "Quote & Grow Your Business",
      title_ar: "قدّم عروضك ونمِّ عملك",
      text_en:
        "Send quotes, connect with clients, and grow your reputation with reviews.",
      text_ar: "قدّم عروض الأسعار، وتواصل مع العملاء، ونمِّ سمعتك من خلال التقييمات.",
    },
  ];

  const handleNext = () => {
    if (current < slides.length - 1) setCurrent(current + 1);
    else handleContinue();
  };

  const handleSkip = () => handleContinue();

  const handleContinue = () => {
    localStorage.setItem("is_onboarding_completed", "true");
    navigate("/login");
  };

  // Swipe Handlers
  const handleTouchStart = (e) => (touchStartX.current = e.touches[0].clientX);
  const handleTouchMove = (e) => (touchEndX.current = e.touches[0].clientX);
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && current < slides.length - 1) setCurrent(current + 1);
      if (diff < 0 && current > 0) setCurrent(current - 1);
    }
  };

  const currentSlide = slides[current];
  const isArabic = lang === "ar";

  return (
    <div
      className={`onboarding-screen d-flex flex-column justify-content-between align-items-center ${
        isArabic ? "rtl" : ""
      }`}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="top-section">
        <img
          src={currentSlide.image}
          alt="Onboarding"
          className="onboard-img slide-animation"
          key={current}
        />
        <h2 className="onboard-title">
          {isArabic ? currentSlide.title_ar : currentSlide.title_en}
        </h2>
        <p className="onboard-text">
          {isArabic ? currentSlide.text_ar : currentSlide.text_en}
        </p>
      </div>

      <div className="bottom-section w-100 text-center">
        {/* Progress Dots */}
        <div className="dots mb-4">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === current ? "active" : ""}`}
            ></span>
          ))}
        </div>

        <div className="d-flex justify-content-between gap-2">
          {current < slides.length - 1 ? (
            <>
              <button className="btn-skip w-50" onClick={handleSkip}>
                {isArabic ? "تخطي" : "Skip"}
              </button>
              <button className="btn-next w-50" onClick={handleNext}>
                {isArabic ? "التالي" : "Continue"}
              </button>
            </>
          ) : (
            <button className="btn-next w-100" onClick={handleContinue}>
              {isArabic ? "ابدأ الآن" : "Continue"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Onboarding;